<template>
<grid-view>
  <template #grid>
    <div v-if="userInfo.isWorksheetVerify && hasWorksheet">
      <div class="table-operator">
        <div>
          <span style="color:#777777;">提交时间：</span>
          <a-select style="width: 240px;" placeholder="请选择时间段" @change="handleChange" allowClear>
            <a-select-option value="current">近1天</a-select-option>
            <a-select-option value="threeDay">近3天</a-select-option>
            <a-select-option value="oneWeek">近1周</a-select-option>
            <a-select-option value="oneMonth">近1个月</a-select-option>
            <a-select-option value="all">全部</a-select-option>
          </a-select>
        </div>
        <div>
          <a-button type="primary" @click="newWorksheet">新建工单</a-button>
        </div>
      </div>
      <a-table ref="table" :columns="grid.columns" :rowKey="(record) => record.worksheetId" :pagination="grid.page.total > 10 ? grid.page.toGrid() : false" @change="handleGrid" :dataSource="grid.data" :locale="local">
        <template slot="name" slot-scope="text, record">
          <div style="overflow: hidden;text-overflow: ellipsis;  display: -webkit-box;-webkit-line-clamp:2;  -webkit-box-orient: vertical;line-break: anywhere;word-break: break-all;" :title="text">{{text}}</div>
        </template>
        <template slot="statusName" slot-scope="text, record">
          <div class="sta" :style="{'--color': record.statusColor}">{{text}}</div>
        </template>
        <template slot="action" slot-scope="text, record">
          <a style="color:#2A57E7" @click="viewWorksheet(text)">查看</a>
        </template>
      </a-table>
    </div>
    <div v-else-if="userInfo.isWorksheetVerify && !hasWorksheet" class="verify-wrapper">
      <div class="welcome">欢迎使用达梦工单服务</div>
      <div class="intro-item1">达梦公司为您提供VIP工单服务，直达高级工程师处理，高效快速的解决您的技术问题。</div>
      <div class="intro-item2">您已认证成功，如遇问题可点击下方“新建工单”。</div>
      <a-button type="primary" @click="newWorksheet">新建工单</a-button>
      <img class="item-img" :src="require('@/assets/worksheet/welcome.svg')" />
    </div>
    <div v-else class="verify-wrapper">
      <div class="welcome">欢迎使用达梦工单服务</div>
      <div class="intro-item1">达梦公司为您提供VIP工单服务，直达高级工程师处理，高效快速的解决您的技术问题。</div>
      <div class="intro-item2">为了保障您的权益，方便达梦售后工程师跟踪服务进度和服务质量，请在提工单之前进行身份认证。</div>
      <a-button type="primary" @click="handleVerify">立即认证</a-button>
      <img class="item-img" :src="require('@/assets/worksheet/welcome.svg')" />
    </div>
  </template>
  <template #extra>
    <company-verify-modal ref="verify" @ok="loadUserInfo"></company-verify-modal>
    <intro-modal ref="intro"></intro-modal>
  </template>
</grid-view>
</template>

<script>
import EmptyIcon from './components/EmptyIcon'
import {
  model,
  router,
  user
} from 'eco-cli'
import CompanyVerifyModal from './Modal/CompanyVerifyModal.vue'
import IntroModal from './Modal/IntroModal.vue'
import Cookies from 'js-cookie'
import moment from 'moment'
import {
  getWorksheetList,
  hasWorksheet
} from '@/request/worksheet'
const {
  Filter,
  Page,
  Sort
} = model;
const {
  getInfo
} = user

export default {
  components: {
    EmptyIcon,
    CompanyVerifyModal,
    IntroModal,
  },
  data() {
    return {
      local: {
        emptyText: (<EmptyIcon text="暂无工单" loading style="padding-top: 84px;" />),
      },
      grid: {
        sort: Sort.new({
          column: "createTime",
        }),
        page: Page.new({
          pageSize: 10,
        }),
        filter: Filter.new(),
        data: [],
        columns: [{
            title: '工单编号',
            width: 150,
            dataIndex: 'worksheetId',
            key: 'worksheetId',
          },
          {
            title: '所属产品',
            dataIndex: 'productTypeName',
            key: 'productTypeName',
            width: 100,
          },
          {
            title: '问题描述',
            dataIndex: 'name',
            key: 'name',
            scopedSlots: {
              customRender: 'name'
            }
          },
          {
            title: '进度',
            key: 'statusName',
            dataIndex: 'statusName',
            width: 100,
            scopedSlots: {
              customRender: 'statusName'
            }
          },
          {
            title: '提交时间',
            width: 180,
            key: 'submitTime',
            dataIndex: 'submitTime',
            sorter: true,
          },
          {
            title: '操作',
            key: 'action',
            width: 100,
            scopedSlots: {
              customRender: 'action',
            },
          },
        ],
      },
      hasWorksheet: true,
      userInfo: {},
    }
  },
  mounted() {
    getInfo(true).then(res => {
      this.userInfo = res;
    });
    this.loadWorksheetList();
    // this.$refs.intro.visible = true;
  },
  methods: {
    handleGrid(pagination, filters, sorter) {
      this.grid.page = Page.fromGrid(pagination);
      if (sorter.order) {
        if (sorter.field === 'submitTime') {
          sorter.field = 'createTime';
        }
        this.grid.sort = Sort.fromGrid(sorter);
      }
      this.loadWorksheetList()
    },
    // 获取工单列表
    loadWorksheetList(resetPage = false) {
      this.local.emptyText = (<EmptyIcon text="暂无工单" loading style="padding-top: 84px;" />);
      hasWorksheet().then((res) => {
        console.log(`shifou res: `, res);
        this.hasWorksheet = res;
        if (res) {
          getWorksheetList({
              page: resetPage ? Page.new({
                pageSize: 10
              }) : this.grid.page,
              filter: this.grid.filter,
              sort: this.grid.sort,
            })
            .then(({
              list,
              page,
              searchCount
            }) => {
              console.log("list, page: ", list, page);
              this.grid.data = list;
              this.grid.page = page;
              this.searchCount = searchCount
            })
            .finally(() => {
              this.local.emptyText = (< EmptyIcon text="暂无工单" style="padding-top: 84px;" />)
            })
        }
      })
    },
    // fresh userIfo
    loadUserInfo() {
      getInfo(true).then(res => {
        this.userInfo = res;
      });
    },
    handleVerify() {
      this.$refs.verify.visible = true
    },
    // 新建表单
    newWorksheet() {
      this.$router.push('/worksheet/new');
    },
    // 日期选择
    handleChange(value) {
      console.log(`selected ${value}`);
      // 开始日期
      var endDate = moment().format('YYYY-MM-DD HH:mm:ss');
      switch (value) { // 结束日期
        case "current":
          var startDate = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss');
          break;
        case "threeDay":
          var startDate = moment().subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss');
          break;
        case "oneWeek":
          var startDate = moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss');
          break;
        case "oneMonth":
          var startDate = moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss');
          break;
        case "all":
          var startDate = "";
          var endDate = "";
          break;
      }
      this.grid.filter.set('startDate', startDate)
      this.grid.filter.set('endDate', endDate)
      this.loadWorksheetList(true);
      console.log(`startDate-endDate: `, startDate, endDate);
    },
    // 查看工单
    viewWorksheet(text) {
      this.$router.push(`/worksheet/${text.worksheetId}`)
    }
  },
}
</script>

<style lang="scss" scoped>
.sta::before {
  content: "";
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background-color: var(--color);
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
}

.grid_page .search {
  margin-bottom: 0 !important;
}

.table-operator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 20px;
}

.verify-wrapper {
  padding: 15px 117px 38px 12px;

  .welcome {
    font-size: 24px;
    font-weight: 600;
    color: #222222;
    line-height: 33px;
  }

  .intro-item1 {
    font-size: 14px;
    font-weight: 500;
    color: #777777;
    line-height: 22px;
    margin-top: 32px;
    margin-bottom: 28px;
  }

  .intro-item2 {
    font-size: 16px;
    font-weight: 500;
    color: #222222;
    line-height: 22px;
    margin-bottom: 35px;
  }

  .item-img {
    width: 855px;
    max-width: initial;
    margin-left: -17px;
  }
}
</style>
